import './styles/index.scss';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BASE_PATH } from '@/configuration';
import App from '@/App';
import { Provider } from 'react-redux';
import { setupStore } from './store';
import { apiStore } from './http/index';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from '@providers/ThemeProvider/ThemeProvider';
import { analyticsManager, AnalyticsProvider, initializeAnalytics, PageViewTracker } from '@/analytics';
import { initErrorHandlers } from '@/errorHandling';
import { AppErrorBoundary } from '@/errorHandling/errorBoundaries/CustomErrorBoundary';

// Инициализация обработчиков ошибок
initErrorHandlers();

// Инициализация Redux стора
const store = setupStore();
apiStore(store);

// Инициализация аналитики
initializeAnalytics();

// Скрываем окно с предложением установить плагин CryptoPRO
window.cadesplugin_skip_extension_install = true;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <StrictMode>
        <AppErrorBoundary>
            <ThemeProvider>
                <Provider store={store}>
                    <BrowserRouter basename={BASE_PATH}>
                        <AnalyticsProvider analytics={analyticsManager}>
                            <PageViewTracker />
                            <App />
                        </AnalyticsProvider>
                    </BrowserRouter>
                </Provider>
            </ThemeProvider>
        </AppErrorBoundary>
    </StrictMode>,
);
